import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrainingDocumentComponent } from './training-document.component';

const routes: Routes = [
  { path: '', component: TrainingDocumentComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrainingDocumentRoutingModule { }
